import { useMutation } from '@tanstack/react-query'
import { queryClient } from '../App'
import { checkAddressExchange } from '../services/CustomerApiService'

export const useConfirmAddress = () => {
  return useMutation(
    {
      mutationKey: ['check-address-exchange'],
      mutationFn: (address: any) => checkAddressExchange(address),
    },
    queryClient,
  )
}
